import React from 'react';
import { Row, Col, Input } from 'antd';
import PropTypes from 'prop-types';
import './Banner1.css';

/*
Required Props
BannerURL
ProfessionalTitle
FirstName
LastName
BusinessStatement
*/
class Banner1 extends React.Component {
    render() {
        // const bannerImageURl = "https://firebasestorage.googleapis.com/v0/b/phros-dev-ddfdb.appspot.com/o/pt-assets%2Fphros%2Fpexels-rfstudio-3820364.jpg?alt=media&token=aa812eaf-b52f-450f-8d84-116d3f0e4ae9";
        const bannerImageURl = this.props.BannerImageURL;
        return (
            <Row>
            <Col xs={24} className="Banner1-Main-Col">
                <div className="Banner1-Main-Div">
                    <img className="Banner1-Img" src={bannerImageURl} alt={this.props.ProfessionalTitle} />
                    <div className="Banner1-Text-Div">
                        <h2 className="Banner1-FirstName">{this.props.FirstName}</h2>
                        <h2 className="Banner1-LastName">{this.props.LastName}</h2>
                        <div className="Banner1-Contact-Section">
                            <Row gutter={[10,10]}>
                                <Col xs={24} sm={18} md={12}>
                                <Input onChange={(e) => this.props.handleChange("Email", e.target.value)} placeholder="Enter E-mail" className="Banner1-Input" />
                                </Col>
                                <Col xs={24} sm={18} md={8}>
                                <button onClick={this.props.submitContact} className="Banner1-Contact-Button">Contact Me</button>
                                </Col>
                            </Row>
                        </div>
                        <h3 className="Banner1-BusinessStatement">{this.props.BusinessStatement}</h3>
                    </div>
                </div>
            </Col>
            </Row>
        )
    }
}

Banner1.propTypes = {
    BannerImageURL: PropTypes.string.isRequired,
    ProfessionalTitle: PropTypes.string.isRequired,
    FirstName: PropTypes.string.isRequired,
    LastName: PropTypes.string.isRequired,
    BusinessStatement: PropTypes.string.isRequired,
}

export default Banner1;